import apiClient from '../utils/apiClient';

export const assetsApi = {
  getAll: (params = {}) => apiClient.get('/assets', { params }).then(res => res.data),
  getById: (id) => apiClient.get(`/assets/${id}`).then(res => res.data),
  getStats: () => apiClient.get('/assets/stats').then(res => res.data),
  create: (data) => apiClient.post('/assets', data).then(res => res.data),
  update: (id, data) => apiClient.put(`/assets/${id}`, data).then(res => res.data),
  assign: (id, employeeId) => apiClient.post(`/assets/${id}/assign`, { employee_id: employeeId }).then(res => res.data),
  return: (id) => apiClient.post(`/assets/${id}/return`).then(res => res.data),
  delete: (id) => apiClient.delete(`/assets/${id}`).then(res => res.data),
  searchByEmployee: (query) => apiClient.get(`/assets/search/employee?query=${encodeURIComponent(query)}`).then(res => res.data),
  exportCSV: () => apiClient.get('/assets/export/csv', { responseType: 'blob' }),
  createAndAssign: (data) => apiClient.post('/assets/create-and-assign', data).then(res => res.data),
};
